export const KUDOS_QUERY_KEY = 'khoros-kudos';
export const KUDOS_MUTATE_SET_KEY = 'khoros-kudos-set';
export const KUDOS_MUTATE_UNSET_KEY = 'khoros-kudos-unset';

export const REPLIES_QUERY_KEY = 'khoros-replies';
export const REPLIES_MUTATE_POST_KEY = 'khoros-replies-post';
export const REPLIES_MUTATE_UPDATE_KEY = 'khoros-replies-update';
export const REPLIES_FLAG_KEY = 'khoros-flag-reply';

export const TOPIC_QUERY_KEY = 'khoros-topic';

export const USER_QUERY_KEY = 'khoros-user';
